import $ from "jquery";

function initArticle(item, config, $article, module) {
	const $body = $article.children(".article-body");
	const $exp = $body.children('.echoed-data[data-key="exp"]');
	$exp.find(".ql-video").wrap(
		$("<div/>").addClass("video-container")
	);
	
	// NEW
	if(
		config.periodNew &&
		!config.periodNew.isAfter(item.dateIssue, "day")
	) {
		$article.addClass("is-new");
	}
}

export { initArticle };
